import { createSlice } from '@reduxjs/toolkit';
import { IProduct } from '../../../utils/models/Product';

export interface ICableEntryData {
  homeData: IProduct[];
  popupData: IProduct[];
  modularSystemData: IProduct[];
  accessoriesData: IProduct[];
  frames: IProduct[];
  masterData: IProduct[];
}

const initialState: ICableEntryData = {
  homeData: [],
  popupData: [],
  modularSystemData: [],
  accessoriesData: [],
  frames: [],
  masterData: [],
};

const cableEntrySlice = createSlice({
  name: 'cableEntry',
  initialState,
  reducers: {
    setHomeData: (state, action) => {
      state.homeData = action.payload;
    },
    setPopupData: (state, action) => {
      state.popupData = action.payload;
    },
    setModularSystemData: (state, action) => {
      state.modularSystemData = action.payload;
    },
    setAccessories: (state, action) => {
      state.accessoriesData = action.payload;
    },
    setFrames: (state, action) => {
      state.frames = action.payload;
    },
    setMasterData: (state, action) => {
      state.masterData = action.payload;
    },
  },
});

export const cableEntryActions = cableEntrySlice.actions;
export default cableEntrySlice.reducer;
